import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { RuntimeAppConfigService } from '@cardapio-online/config';
import { TenantAuthService } from '@cardapio-online/auth';

@Injectable()
export class TenantBaseUrlInterceptor implements HttpInterceptor {
  constructor(
    private readonly runtimeCfg: RuntimeAppConfigService,
    private readonly auth: TenantAuthService
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isAbsolute = /^https?:\/\//i.test(req.url);

    if (!this.runtimeCfg.isLoaded()) {
      return next.handle(req);
    }

    const cfg = this.runtimeCfg.get();
    const base = (cfg.apiBaseUrl ?? '').trim();
    const tenantSlug = (cfg.tenantSlug ?? '').trim();

    const url =
      isAbsolute || !base
        ? req.url
        : `${base}${req.url.startsWith('/') ? '' : '/'}${req.url}`;

    const setHeaders: Record<string, string> = {};
    const token = this.auth.getSnapshot().accessToken;
    const shouldAttachTenantHeader =
      !!tenantSlug &&
      !req.headers.has('X-Tenant-Slug') &&
      (!isAbsolute || (!!base && req.url.startsWith(base)));

    if (shouldAttachTenantHeader) {
      setHeaders['X-Tenant-Slug'] = tenantSlug;
    }

    if (token && !isAbsolute && !req.headers.has('Authorization')) {
      setHeaders['Authorization'] = `Bearer ${token}`;
    }

    if (url === req.url && Object.keys(setHeaders).length === 0) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        url,
        setHeaders,
      })
    );
  }
}
